const r = /* @__PURE__ */ new Set([
  "trace",
  "debug",
  "info",
  "warn",
  "error",
  "fatal",
  "silent"
]), n = {
  verbose: "trace",
  log: "info"
}, s = (t) => {
  const e = (t ?? "info").toLowerCase();
  return n[e] ?? (r.has(e) ? e : "info");
}, a = (t, e, o) => o || e.statusCode >= 500 ? "error" : e.statusCode >= 400 ? "warn" : "info", u = (t, e) => `${t.method ?? "-"} ${t.url ?? "-"} ${e.statusCode ?? "-"}`;
export {
  n as LEVEL_ALIASES,
  r as PINO_LEVELS,
  a as customLogLevel,
  u as httpMessage,
  s as normalizeLevel
};
